import React from "react";
import { PrimeReactProvider } from "primereact/api";
import AutoSuggest from "./AutoSuggest";

function App() {
    return (
        <PrimeReactProvider>
            <AutoSuggest></AutoSuggest>
        </PrimeReactProvider>
    );
}

export default App;
